import { RouteConfig } from 'vue-router';
import blockStorageRoutes from './block-storage.routes';
import abgwRoutes from './abgw.routes';
import s3Routes from './s3.routes';
import nfsRoutes from './nfs.routes';
import fileStorage from './fileStorage.routes';

const list: Array<RouteConfig> = [
  ...blockStorageRoutes,
  ...abgwRoutes,
  ...s3Routes,
  ...nfsRoutes,
  ...fileStorage
];

export default list;
